var map = {
	"./adminAvatar/DanAvatar.png": 999,
	"./adminAvatar/GergelyAvatar.png": 1000,
	"./adminAvatar/avatarHeader.png": 1001,
	"./adminAvatar/userDefaultAvatar.png": 419,
	"./avatarHeader.png": 2085,
	"./bg-blue.png": 2086,
	"./bg-green.png": 2087,
	"./bg-purple.png": 2088,
	"./bg-red.png": 2089,
	"./cardImage.png": 1002,
	"./img-default.png": 420,
	"./levicaLogo.svg": 743,
	"./login.jpg": 79,
	"./mail.png": 995,
	"./pass.png": 994,
	"./qrCode.png": 2090,
	"./userDefaultAvatar.jpg": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2084;